'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lurkerViewMessageEvt = exports.lurkerFillEvt = exports.lurkerClickEvt = exports.setPageName = exports.lurkerPageLoadEvt = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _helper = require('./helper');
var _helper2 = _interopRequireDefault(_helper);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var pageName = void 0;

/* eslint-disable */
try {
  pageName = window.dataLayer && window.dataLayer[0] && window.dataLayer[0].page && window.dataLayer[0].page.pageType ? window.dataLayer[0].page.pageType : '';
} catch (error) {
  console.error('Error getting pageType: ' + error);
}
/* eslint-enable */

var lurkerPageLoadEvt = exports.lurkerPageLoadEvt = function lurkerPageLoadEvt() {
  return (0, _helper2.default)({
    event_type: 'page_view',
    object_detail: 'load',
    object_name: pageName
  });
};
var setPageName = exports.setPageName = function setPageName(name) {
  pageName = name;
  lurkerPageLoadEvt();
};
var lurkerClickEvt = exports.lurkerClickEvt = function lurkerClickEvt(detail) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _helper2.default)({
    event_type: 'click',
    object_detail: detail,
    object_name: pageName,
    data: data
  });
};
var lurkerFillEvt = exports.lurkerFillEvt = function lurkerFillEvt(detail) {
  return (0, _helper2.default)({
    event_type: 'fill',
    object_detail: detail,
    object_name: pageName
  });
};
var lurkerViewMessageEvt = exports.lurkerViewMessageEvt = function lurkerViewMessageEvt(detail, extraData) {
  return (0, _helper2.default)((0, _extends3.default)({}, extraData, {
    event_type: 'message_view',
    object_detail: detail,
    object_name: pageName
  }));
};
exports.default = {
  setPageName: setPageName,
  lurkerPageLoadEvt: lurkerPageLoadEvt,
  lurkerClickEvt: lurkerClickEvt,
  lurkerFillEvt: lurkerFillEvt,
  lurkerViewMessageEvt: lurkerViewMessageEvt
};